import { Skeleton, Space, Spin, Timeline, Typography } from 'antd';
import { InfiniteScroll } from 'components/common';
import dayjs from 'dayjs';
import { useShiftsUser } from 'hooks';
import { groupBy } from 'lodash';
import { shiftsMessages } from 'messages';
import { colorsBase } from 'themes';
import { UserShiftDto } from 'types';
import { TIME_STAMP_FORMAT, USER_SHIFT_TYPE, WEEKDAY_FORMAT } from 'utils';

type UserShiftTabProps = {
  userId: number;
};
const UserShiftTab = ({ userId }: UserShiftTabProps) => {
  const { userShift, isLoading, handleLoadMore, hasMore } = useShiftsUser(userId);
  const groupedShifts = groupBy(userShift, (o) => dayjs(o.createdAt).format(WEEKDAY_FORMAT));

  const renderAction = (shift: UserShiftDto) => {
    switch (shift.type) {
      case USER_SHIFT_TYPE.LOGIN:
        return (
          <div className='flex w-full justify-between'>
            <Typography.Text>{shiftsMessages.login}</Typography.Text>
            <Typography.Text type='secondary'>{dayjs(shift.createdAt).format(TIME_STAMP_FORMAT)}</Typography.Text>
          </div>
        );
      case USER_SHIFT_TYPE.LOGOUT:
        return (
          <div className='flex w-full justify-between'>
            <Typography.Text>{shiftsMessages.logout}</Typography.Text>
            <Typography.Text type='secondary'>{dayjs(shift.createdAt).format(TIME_STAMP_FORMAT)}</Typography.Text>
          </div>
        );
      default:
        return (
          <div className='flex w-full justify-between'>
            <Space>
              <Typography.Text>{shiftsMessages.startShifts} </Typography.Text>
              <Space split={<Typography.Text className='font-semibold'>-</Typography.Text>}>
                <Typography.Text className='font-semibold'>{shift.code}</Typography.Text>
                <Typography.Text className='font-semibold'>{shift.name}</Typography.Text>
                <Typography.Text className='font-semibold'>{shift.fromTime}</Typography.Text>
                <Typography.Text className='font-semibold'>{shift.toTime}</Typography.Text>
              </Space>
            </Space>
            <Typography.Text type='secondary'>{dayjs(shift.createdAt).format(TIME_STAMP_FORMAT)}</Typography.Text>
          </div>
        );
    }
  };

  if (isLoading)
    return (
      <Skeleton
        paragraph={{
          rows: 10
        }}
      />
    );
  return (
    <InfiniteScroll
      isLoading={isLoading}
      next={handleLoadMore}
      hasMore={hasMore}
      loader={<Spin spinning={isLoading}></Spin>}
      endMessage={<p></p>}
    >
      {Object.keys(groupedShifts).map((date) => (
        <div key={date} className='mb-6'>
          <Typography.Paragraph className='mb-4'>{date}</Typography.Paragraph>
          <Timeline
            items={groupedShifts[date].map((shift) => ({
              color: colorsBase.colorTextDescription,
              dot: <div className='h-2 w-2 rounded-full bg-colorTextDescription' />,
              children: renderAction(shift)
            }))}
          />
        </div>
      ))}
    </InfiniteScroll>
  );
};
export default UserShiftTab;
